import Emittery from "emittery";
import { SubmissionValueProvider } from "./SubmissionValueProvider";
import { CachedContractsLoader } from "../controller/CachedContractsLoader";
export class SubmissionController extends Emittery {
    constructor(submission) {
        super();
        this.submission = submission;
        this.dumbapp = null;
        this.contractsLoader = new CachedContractsLoader();
        this.values = new SubmissionValueProvider(submission);
        this.dumbapp = submission?.dumbapp;
    }
    get lastResolve() {
        return this.lastResolveResult;
    }
    setApi(api) {
        this.contractsLoader.setApi(api);
    }
    setSubmission(submission) {
        if (submission) {
            this.dumbapp = submission.dumbapp;
            this.submission = submission;
            this.values.setSubmission(submission);
            this.trigger();
        }
    }
    placeholderText() {
        return "None";
    }
    trigger() {
        this.emit("change", this.values);
        this.doResolve();
    }
    submissionStep(index) {
        return this.submission?.data?.steps?.[index];
    }
    doResolve() {
        this.contractsLoader
            .handler({
            dumbapp: this.dumbapp,
        }, this.submission.data.args)
            .then((result) => {
            if (result.success === true) {
                this.lastResolveResult = {
                    success: true,
                    arguments: this.submission.data.args.map((it, index) => {
                        return {
                            ...it,
                            contract: result.data[index],
                        };
                    }),
                    values: this.values,
                    state: null
                };
                this.emit("resolve", this.lastResolveResult);
            }
            else {
                this.emit("resolve", result);
            }
        });
    }
}
